// eslint-disable-next-line import/prefer-default-export
export function getAppVersion() {
  return process.env.REACT_APP_VERSION || 'N/A';
}
